/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Link_HelpInputs */

const en_signin_link_help = /** @type {(inputs: Signin_Link_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We send a one-time link to this address. Open it on this device.`)
};

/** @type {(inputs: Signin_Link_HelpInputs) => LocalizedString} */
const ar_signin_link_help = en_signin_link_help;

/** @type {(inputs: Signin_Link_HelpInputs) => LocalizedString} */
const he_signin_link_help = en_signin_link_help;

/** @type {(inputs: Signin_Link_HelpInputs) => LocalizedString} */
const ur_signin_link_help = en_signin_link_help;

/** @type {(inputs: Signin_Link_HelpInputs) => LocalizedString} */
const es_signin_link_help = en_signin_link_help;

/** @type {(inputs: Signin_Link_HelpInputs) => LocalizedString} */
const fr_signin_link_help = en_signin_link_help;

/** @type {(inputs: Signin_Link_HelpInputs) => LocalizedString} */
const de_signin_link_help = en_signin_link_help;

/** @type {(inputs: Signin_Link_HelpInputs) => LocalizedString} */
const pt_signin_link_help = en_signin_link_help;

/** @type {(inputs: Signin_Link_HelpInputs) => LocalizedString} */
const hi_signin_link_help = en_signin_link_help;

/** @type {(inputs: Signin_Link_HelpInputs) => LocalizedString} */
const bn_signin_link_help = en_signin_link_help;

/**
* | output |
* | --- |
* | "We send a one-time link to this address. Open it on this device." |
*
* @param {Signin_Link_HelpInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_link_help = /** @type {((inputs?: Signin_Link_HelpInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Link_HelpInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_link_help(inputs)
	if (locale === "he") return he_signin_link_help(inputs)
	if (locale === "ur") return ur_signin_link_help(inputs)
	if (locale === "es") return es_signin_link_help(inputs)
	if (locale === "fr") return fr_signin_link_help(inputs)
	if (locale === "de") return de_signin_link_help(inputs)
	if (locale === "pt") return pt_signin_link_help(inputs)
	if (locale === "hi") return hi_signin_link_help(inputs)
	if (locale === "bn") return bn_signin_link_help(inputs)
	return /** @type {LocalizedString} */ ("We send a one-time link to this address. Open it on this device.")
});